import apiClient2 from "@/shared/api/apiClient2";

export const getTemplateItem = async (code) => {
  try {
    const { data } = await apiClient2.get(
      `/participants-cabinet/templates/${code}`
    );
    return data;
  } catch (e) {
    console.error("[template] getTemplateItem", e);
  }
};

export const getTemplateGroupedList = async (params) => {
  try {
    const { data } = await apiClient2.get("/templates/list/grouped/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("[template] getTemplateGroupedList", e);
  }
};
